import { createBrowserCallService, webBrowserServices } from '@almadar/integrations/browser';

export const browserCallService = createBrowserCallService(webBrowserServices(['analytics']));
